import { Box } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import type { PlanConfig, Segment } from '../types';
import { SegmentCard } from './SegmentCard';

interface SortableSegmentCardProps {
  segment: Segment;
  index: number;
  config: PlanConfig;
  canDelete: boolean;
  showDeleteIcon?: boolean;
  onNameChange: (idx: number, name: string) => void;
  onPctChange: (idx: number, value: number) => void;
  onStartDayChange: (idx: number, value: number) => void;
  onRequestDelete: (idx: number) => void;
  nameOptions: string[];
}

/** Drag-sortable wrapper around {@link SegmentCard}. */
export const SortableSegmentCard = (props: SortableSegmentCardProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: String(props.segment.id) });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 1 : undefined,
  };

  return (
    <Box ref={setNodeRef} style={style}>
      <SegmentCard {...props} dragHandleProps={{ ...attributes, ...listeners }} />
    </Box>
  );
};
